module.exports = __webpack_public_path__ + "img/Animations_mariage.eb63313.jpg";